// extracted by mini-css-extract-plugin
module.exports = {"quote-container":"_1RkOdxDyx0NzwLx5Ld5_Fu","preLoaderShimmer":"_150--GdQoLjrwSj9POhD5S"};